import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xcXR0NWJoMCB7CiAgcGFkZGluZy1ib3R0b206IDIycHg7Cn0';
export var contentWithDashedPaddingClass = '_1qtt5bh0';